import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hasToken, hasAttemptedLogin, getFacebookLoginUrl } from '../selectors/user';
import { extractTokenFromUrl } from '../actions/user';
import Loader from '../components/Loader';
import { hardRedirectTo } from '../store/redirectMiddleware';

class RedirectToLogin extends Component {
  static propTypes = {
    redirect: PropTypes.func.isRequired
  };

  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.props.redirect(`/login?from=${window.location.pathname}`);
    }
  }
  render() {
    return false;
  }
}

class LoginGate extends Component {
  UNSAFE_componentWillMount() {
    this.props.extractTokenFromUrl();
  }
  render() {
    const { hasToken, hasAttemptedLogin, children, hardRedirectTo } = this.props;
    if (SERVER) return <Loader />; //eslint-disable-line no-undef
    // return children; //  UNCOMMENT THIS TO DISABLE LOGIN
    if (!hasAttemptedLogin) {
      return <Loader />;
    }
    if (hasToken) {
      return children;
    }
    return <RedirectToLogin redirect={hardRedirectTo} />;
  }
}

LoginGate.propTypes = {
  hasAttemptedLogin: PropTypes.bool,
  hasToken: PropTypes.bool,
  children: PropTypes.node,
  facebookUrl: PropTypes.string,
  extractTokenFromUrl: PropTypes.func.isRequired,
  hardRedirectTo: PropTypes.func.isRequired
};

export default connect(
  state => ({
    hasAttemptedLogin: hasAttemptedLogin(state),
    hasToken: hasToken(state),
    facebookUrl: getFacebookLoginUrl(state)
  }),
  {
    extractTokenFromUrl,
    hardRedirectTo
  }
)(LoginGate);
